import { Resources } from '@shared/localizations/Resources';
import { OperationType } from '../Trading/OperationType';
import { InstrumentTypes } from './InstrumentTypes';
import { QuotingType } from './QuotingType';
export class BoughtSoldUtils {
    static IsLong(item) {
        return item.BuySell === OperationType.Buy;
    }
    static Bought(item) {
        return this.boughtSoldVolume(item.BuySell === OperationType.Buy, item.getAmount(), item.Price, item.Instrument);
    }
    static BoughtStr(item) {
        return this.boughtSoldVolumeStr(item, true);
    }
    static Sold(item) {
        return this.boughtSoldVolume(item.BuySell !== OperationType.Buy, item.getAmount(), item.Price, item.Instrument);
    }
    static SoldStr(item) {
        return this.boughtSoldVolumeStr(item, false);
    }
    static boughtSoldVolume(usePriceMultiplier, quantity, price, instrument) {
        if (isNullOrUndefined(instrument)) {
            return 0;
        }
        const nonMultipliedTypes = [
            InstrumentTypes.FUTURES,
            InstrumentTypes.CFD_FUTURES,
            InstrumentTypes.OPTIONS,
            InstrumentTypes.SPREADBET
        ];
        const shouldBeMultipliedByLotSize = !nonMultipliedTypes.Contains(instrument.InstrType);
        const result = usePriceMultiplier
            ? quantity *
                (instrument.QuotingType === QuotingType.LotSize && shouldBeMultipliedByLotSize ? instrument.LotSize : 1)
            : quantity *
                price *
                (instrument.QuotingType === QuotingType.LotSize ? instrument.LotSize : instrument.GetTickCost()) *
                instrument.GetFaceValueMultiplier();
        return result;
    }
    static boughtSoldVolumeStr(item, isBought) {
        var _a, _b;
        const instrument = item.Instrument;
        if (item.Price === 0 || isNullOrUndefined(instrument)) {
            return isBought ? ((_a = item.boughtString) !== null && _a !== void 0 ? _a : '-') : ((_b = item.soldString) !== null && _b !== void 0 ? _b : '-');
        }
        const value = isBought ? this.Bought(item) : this.Sold(item);
        const isLong = this.IsLong(item);
        return this.FormatTextBoughtSold(instrument, value, isLong, isBought);
    }
    static FormatTextBoughtSold(instrument, value, isLong, isBought) {
        const exp1Asset = instrument.DataCache.GetAssetByName(instrument.Exp1);
        const exp2Asset = instrument.DataCache.GetAssetByName(instrument.Exp2);
        const isPositiveTrade = (isLong && isBought) || (!isLong && !isBought);
        if (isPositiveTrade) {
            if (instrument.isFutureOrOption() || instrument.InstrType === InstrumentTypes.CFD_FUTURES) {
                return `${value} ${Resources.getResource('Instrument.Futures.contract')}`;
            }
            else if (instrument.InstrType === InstrumentTypes.SPREADBET) {
                return `${value} ${Resources.getResource('Instrument.Spreadbet.bet')}`;
            }
            else if (instrument.InstrType === InstrumentTypes.EQUITIES ||
                instrument.InstrType === InstrumentTypes.FUND ||
                instrument.InstrType === InstrumentTypes.ETF ||
                instrument.InstrType === InstrumentTypes.FIXED_INCOME) {
                return `${value} ${instrument.DisplayName()}`;
            }
            else if (instrument.InstrType === InstrumentTypes.CORPORATE) {
                return `${value} ${Resources.getResource('Instrument.Corporate.Securities')}`;
            }
            else {
                return exp1Asset != null ? exp1Asset.formatPrice(value) : `${value} ${instrument.Exp1}`;
            }
        }
        else {
            return exp2Asset != null ? exp2Asset.formatPrice(value) : `${value} ${instrument.Exp2}`;
        }
    }
}
